import { DateTime } from 'luxon';

export function toDateString(date: Date | string | undefined): string {
    if (date === undefined) {
        return '';
    }
    return safeDateTime(date).toFormat('HH:mm:ss SSS');
}

export function toDateTimeString(date: Date | string | undefined): string {
    if (date === undefined) {
        return '';
    }
    return safeDateTime(date).toFormat('yyyy-MM-dd HH:mm:ss SSS');
}

export function safeDateTime(date: Date | string): DateTime {
    return typeof date === 'string'
        ? DateTime.fromJSDate(new Date(date))
        : DateTime.fromJSDate(date);
}
